/**
 * DeviceListReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * DeviceListReq
 */
export interface DeviceListReq {
  /** 搜索关键词 */
  q?: string
  /** 是否删除 */
  deleted?: boolean
  /** 页码 */
  page?: number
  /** 每页数量 */
  page_size?: number
  /** 排序字段 */
  order_by?: string
  /** 排序方向 */
  order?: string
  /** 创建时间范围 (start,end) */
  created_at__range?: any
  /** 更新时间范围 (start,end) */
  updated_at__range?: any
  /** 更新时间距今 (7d/1h/30m) */
  updated_at__since?: any
  /** 禁用状态 */
  disabled?: boolean
  /** ID列表 */
  id__in?: string[]
  /** 应用平台（ios/android/web） */
  platform?: string
  /** 设备操作系统 */
  os?: string
  /** 设备类型 */
  type?: string
  /** 应用平台列表 */
  platform__in?: string[]
  /** 设备操作系统列表 */
  os__in?: string[]
  /** 设备类型列表 */
  type__in?: string[]
  /** 设备名称包含 */
  name__like?: string
  /** 设备型号包含 */
  model__like?: string
  /** 设备品牌包含 */
  brand__like?: string
  /** 应用版本包含 */
  app_version__like?: string
  /** 系统版本包含 */
  os_version__like?: string
  /** 最后活跃时间距今(如:7d,1h,30m) */
  last_active_at__since?: any
  /** 最后活跃时间早于(如:7d,1h,30m) */
  last_active_at__before?: any
}

/**
 * DeviceListReq Schema
 */
export const DeviceListReqSchema: SchemaDefinition = {
  properties: {
    q: {
      description: '搜索关键词',
      format: 'string',
      type: 'string',
      label: '搜索关键词',
    },
    deleted: {
      description: '是否删除',
      format: '*bool',
      type: 'boolean',
      label: '是否删除',
    },
    page: {
      description: '页码',
      format: 'int',
      type: 'integer',
      label: '页码',
    },
    page_size: {
      description: '每页数量',
      format: 'int',
      type: 'integer',
      label: '每页数量',
    },
    order_by: {
      description: '排序字段',
      format: 'string',
      type: 'string',
      label: '排序字段',
    },
    order: {
      description: '排序方向',
      format: 'string',
      type: 'string',
      label: '排序方向',
    },
    created_at__range: {
      description: '创建时间范围 (start,end)',
      format: '[]string',
      type: 'datetime',
      label: '创建时间范围',
    },
    updated_at__range: {
      description: '更新时间范围 (start,end)',
      format: '[]string',
      type: 'datetime',
      label: '更新时间范围',
    },
    updated_at__since: {
      description: '更新时间距今 (7d/1h/30m)',
      format: '[]string',
      type: 'datetime',
      label: '更新时间距今',
    },
    disabled: {
      description: '禁用状态',
      format: '*bool',
      type: 'boolean',
      label: '禁用状态',
    },
    id__in: {
      description: 'ID列表',
      format: '[]string',
      items: {
        format: 'string',
        type: 'string',
      },
      type: 'array',
      label: 'ID列表',
    },
    platform: {
      description: '应用平台（ios/android/web）',
      format: 'cons.AppPlatform',
      type: 'string',
      label: '应用平台',
    },
    os: {
      description: '设备操作系统',
      format: 'cons.DeviceOs',
      type: 'string',
      label: '设备操作系统',
    },
    type: {
      description: '设备类型',
      format: 'cons.DeviceType',
      type: 'string',
      label: '设备类型',
    },
    platform__in: {
      description: '应用平台列表',
      format: '[]cons.AppPlatform',
      items: {
        format: 'cons.AppPlatform',
        type: 'string',
      },
      type: 'array',
      label: '应用平台列表',
    },
    os__in: {
      description: '设备操作系统列表',
      format: '[]cons.DeviceOs',
      items: {
        format: 'cons.DeviceOs',
        type: 'string',
      },
      type: 'array',
      label: '设备操作系统列表',
    },
    type__in: {
      description: '设备类型列表',
      format: '[]cons.DeviceType',
      items: {
        format: 'cons.DeviceType',
        type: 'string',
      },
      type: 'array',
      label: '设备类型列表',
    },
    name__like: {
      description: '设备名称包含',
      format: 'string',
      type: 'string',
      label: '设备名称包含',
    },
    model__like: {
      description: '设备型号包含',
      format: 'string',
      type: 'string',
      label: '设备型号包含',
    },
    brand__like: {
      description: '设备品牌包含',
      format: 'string',
      type: 'string',
      label: '设备品牌包含',
    },
    app_version__like: {
      description: '应用版本包含',
      format: 'string',
      type: 'string',
      label: '应用版本包含',
    },
    os_version__like: {
      description: '系统版本包含',
      format: 'string',
      type: 'string',
      label: '系统版本包含',
    },
    last_active_at__since: {
      description: '最后活跃时间距今(如:7d,1h,30m)',
      format: '*string',
      type: 'datetime',
      label: '最后活跃时间距今',
    },
    last_active_at__before: {
      description: '最后活跃时间早于(如:7d,1h,30m)',
      format: '*string',
      type: 'datetime',
      label: '最后活跃时间早于',
    },
  },
  type: 'object',
}
